import { render, staticRenderFns } from "./covidQuestions.vue?vue&type=template&id=20c8934e&"
import script from "./covidQuestions.vue?vue&type=script&lang=js&"
export * from "./covidQuestions.vue?vue&type=script&lang=js&"
import style0 from "./covidQuestions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports